import * as React from "react";
const SvgFiRrPercent25 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-percent-25_svg__a)">
      <path
        fill="#062147"
        d="M21.122 18.229a1 1 0 0 1 .135 1.408A11.97 11.97 0 0 1 12 24C5.383 24 0 18.617 0 12S5.383 0 12 0a11.97 11.97 0 0 1 9.257 4.363 1 1 0 0 1-1.543 1.274A9.97 9.97 0 0 0 12 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.97 9.97 0 0 0 7.714-3.637 1 1 0 0 1 1.408-.134m1.628-4.748a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-3.25-4.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m-1.156 6.75a.8.8 0 0 0 .67-.363l4.178-6.4a.8.8 0 1 0-1.34-.874l-4.178 6.4a.8.8 0 0 0 .67 1.237m-8.33-5.381C10.014 9.166 8.886 8 7.5 8s-2.514 1.167-2.514 2.6a.8.8 0 1 0 1.6 0c0-.552.41-1 .915-1s.915.449.915 1c0 .562-.841 1.188-1.584 1.739-.914.679-1.859 1.382-1.859 2.411 0 .606.431 1.25 1.229 1.25h3a.8.8 0 1 0 0-1.6H6.824c.268-.26.691-.575.963-.777.993-.738 2.229-1.657 2.229-3.023zm3.486 3.8h-1.7a.8.8 0 1 0 0 1.6h1.7c1.379 0 2.5-1.122 2.5-2.5S14.879 11 13.5 11h-.9V9.8c0-.11.09-.2.2-.2h1.9a.8.8 0 0 0 0-1.6h-1.9c-.993 0-1.8.807-1.8 1.8v1.5c0 .717.583 1.3 1.3 1.3h1.2c.496 0 .9.404.9.9s-.404.9-.9.9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-percent-25_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPercent25;
